import { GetterTree } from "vuex";
import * as types from "@/store/constants/types";
const Getters: GetterTree<any, any> = {
  [types.GETTER_CURRENT_INS_MEDIA_LIST_INFO](state, getters, rootState) {
    if (rootState.currentUserId == null || rootState.userList.length === 0) {
      return null;
    } else {
      const insUserMedia = state.insUserMediaList.find((user: any) => {
        return user.userId === rootState.currentUserId;
      });
      return insUserMedia;
    }
  },
  [types.GETTER_CURRENT_INS_MEDIA_INFO](state, getters, rootState) {
    return (type: string) => {
      if (rootState.currentUserId == null || rootState.userList.length === 0) {
        return null;
      }
      const insUserMedia = state.insUserMediaList.find((user: any) => {
        return user.userId === rootState.currentUserId;
      });
      if (type === "post") {
        const currentMedia = insUserMedia.insMediaList.find((post: any) => {
          return post.id === rootState.currentPostId;
        });
        return currentMedia === undefined ? null : currentMedia;
      } else if (type === "view") {
        const currentMedia = insUserMedia.insMediaList.find((post: any) => {
          return post.id === rootState.currentViewId;
        });
        return currentMedia === undefined ? null : currentMedia;
      }
    };
  },
  [types.GETTER_CURRENT_INS_MEDIA_MORE_AVAILABLE_TAGS](
    state,
    getters,
    rootState
  ) {
    if (rootState.currentUserId == null || rootState.userList.length === 0) {
      return false;
    } else {
      const insUserMedia = state.insUserMediaList.find((user: any) => {
        return user.userId === rootState.currentUserId;
      });
      if (insUserMedia !== undefined) {
        return insUserMedia.moreAvaliable;
      } else {
        return false;
      }
    }
  }
};

export default Getters;
